
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(2 1)"}},[_c('path',{attrs:{"d":"M14.25 2.625v16.5c0 1.846 1.274 2.875 2.625 2.875 1.25 0 2.625-.875 2.625-2.875V2.75C19.5 1.058 18.25 0 16.875 0S14.25 1.166 14.25 2.625z","fill":"#F9AB00"}}),_c('path',{attrs:{"d":"M7.375 11v8.125C7.375 20.971 8.649 22 10 22c1.25 0 2.625-.875 2.625-2.875v-8c0-1.693-1.25-2.75-2.625-2.75S7.375 9.541 7.375 11z","fill":"#E37400"}}),_c('circle',{attrs:{"fill":"#E37400","cx":"3.125","cy":"19.375","r":"2.625"}})])])
          )
        }
      }
    